import { render, staticRenderFns } from "./TopicCongress.vue?vue&type=template&id=374219b2"
import script from "./TopicCongress.vue?vue&type=script&lang=js"
export * from "./TopicCongress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports